const defaults = {
    breadcrumbs: {
      dark: false,
      divider: '/',
      items: [],
      large: false,
      light: false
    }
  }

  const state = {
    breadcrumbs: defaults.breadcrumbs
  }

  const mutations = {
    set (state, breadcrumbs) {
      breadcrumbs = Object(breadcrumbs)
      state.breadcrumbs = Object.assign({}, state.breadcrumbs, breadcrumbs)
    },

    reset (state) {
      state.breadcrumbs = Object.assign({}, defaults.breadcrumbs)
    },

    setItems (state, items) {
      state.breadcrumbs.items = items
    },

    resetItems (state) {
      state.breadcrumbs.items = []
    }
  }

  const getters = {
    get (state) {
      return state.breadcrumbs
    },
    getItems () {
      return state.breadcrumbs.items || []
    }
  }

  const actions = {}

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }
